module.exports = __webpack_public_path__ + "img/hero-title-pc.70588902.png";